import React, { createContext, useState } from "react";

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
    const [selectedDashboard, setSelectedDashboard] = useState("Hitachi Overall Dashboard");
    const [dashboardKey, setDashboardKey] = useState(0);

    return (
        <DashboardContext.Provider
            value={{
                selectedDashboard,
                setSelectedDashboard,
                dashboardKey,
                setDashboardKey,
            }}
        >
            {children}
        </DashboardContext.Provider>
    );
};
